import { OpenAPIRequestBody } from './OpenAPIRequestBody';
import { OpenAPIResponses } from './OpenAPIResponses';
import { OpenAPISchemaProperties } from './OpenAPISchemaServer';
import { OpenAPISecurities } from './OpenAPISecurities';
import { StaticSection } from './StaticSection';
import { tString } from './translate';
import { parameterToProperty } from './utils';
export function OpenAPISpec(props) {
    var _a;
    var data = props.data, context = props.context;
    var operation = data.operation;
    var parameters = (_a = operation.parameters) !== null && _a !== void 0 ? _a : [];
    var parameterGroups = groupParameters(parameters, context);
    var securities = 'securities' in data ? data.securities : [];
    return (<>
            {securities.length > 0 ? (<OpenAPISecurities key="securities" securities={securities} context={context}/>) : null}

            {parameterGroups.map(function (group) {
            return (<StaticSection key={"parameter-".concat(group.key)} className="openapi-parameters" header={group.label}>
                        <OpenAPISchemaProperties properties={group.parameters.map(parameterToProperty)} context={context}/>
                    </StaticSection>);
        })}

            {operation.requestBody ? (<OpenAPIRequestBody key="body" requestBody={operation.requestBody} context={context} data={data}/>) : null}
            {operation.responses ? (<OpenAPIResponses key="responses" responses={operation.responses} context={context}/>) : null}
        </>);
}
function groupParameters(parameters, context) {
    var sorted = ['path', 'query', 'header'];
    var groups = [];
    parameters
        .filter(function (parameter) { return parameter.in; })
        .forEach(function (parameter) {
        var key = parameter.in;
        var label = getParameterGroupName(parameter.in, context);
        var group = groups.find(function (group) { return group.key === key; });
        if (group) {
            group.parameters.push(parameter);
        }
        else {
            groups.push({
                key: key,
                label: label,
                parameters: [parameter],
            });
        }
    });
    groups.sort(function (a, b) { return sorted.indexOf(a.key) - sorted.indexOf(b.key); });
    return groups;
}
function getParameterGroupName(paramIn, context) {
    switch (paramIn) {
        case 'path':
            return tString(context.translation, 'path_parameters');
        case 'query':
            return tString(context.translation, 'query_parameters');
        case 'header':
            return tString(context.translation, 'header_parameters');
        default:
            return paramIn;
    }
}
